import { RECORDING_REMINDER_OPTIONS, type RecordingReminderPreference } from '@terros/common'
import { type SelectItem } from './types'

export function getRecordingReminderLabel(option: RecordingReminderPreference): string {
  if (option === 'Always') return 'Always remind when taking a canvass action'
  if (option === 'Daily') return 'Remind once per day when taking a canvass action'
  return 'Never remind when taking a canvass action'
}

export const RECORDING_REMINDER_ITEMS: SelectItem<RecordingReminderPreference>[] = RECORDING_REMINDER_OPTIONS.map(
  (option) => ({
    label: getRecordingReminderLabel(option),
    value: option,
  })
)
